import {
  faCheck,
  faSparkles,
  faXmark,
} from "@fortawesome/pro-regular-svg-icons";

import { Toolbar } from "src/design-system/Toolbar";

type HintedFieldRowProps = {
  fieldKey: string;
  isHinted: boolean;
  onApprove: () => void;
  onReject: () => void;
  onRewriteWithCopilot: () => void;
  disabled: boolean;
  children: React.ReactNode;
};

export const HintedFieldRow: React.FC<HintedFieldRowProps> = ({
  fieldKey,
  isHinted,
  onApprove,
  onReject,
  onRewriteWithCopilot,
  disabled,
  children,
}) => (
  <div className="group/hint relative">
    {children}
    <div className="absolute -top-2 right-0 z-10 opacity-0 transition-opacity group-hover/hint:opacity-100">
      <Toolbar dataLoc={`hint-toolbar-${fieldKey}`}>
        {isHinted && (
          <>
            <Toolbar.IconButton
              disabled={disabled}
              icon={faCheck}
              tooltip="Accept"
              onClick={onApprove}
            />
            <Toolbar.IconButton
              disabled={disabled}
              icon={faXmark}
              tooltip="Dismiss"
              onClick={onReject}
            />
          </>
        )}
        <Toolbar.IconButton
          disabled={disabled}
          icon={faSparkles}
          tooltip="Rewrite with Copilot"
          onClick={onRewriteWithCopilot}
        />
      </Toolbar>
    </div>
  </div>
);
